import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Optional,
  ElementRef,
  ViewChild,
  Renderer2,
  SecurityContext,
} from '@angular/core'
import {
  CmsSearchBoxComponent,
  WindowRef,
  AuthService,
  GlobalMessageType,
  GlobalMessageService,
  CurrencyService,
} from '@spartacus/core'
import { Observable, of, Subscription } from 'rxjs'
import { map, switchMap, tap, filter, take } from 'rxjs/operators'
import {
  ICON_TYPE,
  CurrentProductService,
  LaunchDialogService,
} from '@spartacus/storefront'
import { CmsComponentData } from '@spartacus/storefront'
import { SearchBoxComponentService } from './search-box-component.service'
import { SearchBoxConfig, SearchResults } from './search-box.model'
import { Router } from '@angular/router'
import { QuoteCartService } from '../quote/quote-services/quote-cart.service'
import { Actions, ofType } from '@ngrx/effects'
import { ChangeDetectorRef } from '@angular/core'
import { CheckoutService } from '../cart/checkout/checkout/checkout.service'
import { PDPService } from '../pdp/services/pdp.services'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { DomSanitizer } from '@angular/platform-browser'
import { BulkServiceService } from '../bulk-order/bulk-service.service'
import { ShoppingCartService } from '../cart/cart-shared/cart.service'
import {
  ActiveCartFacade,
  MultiCartFacade,
  OrderEntry,
} from '@spartacus/cart/base/root'
import { OccCartAdapter } from '@spartacus/cart/base/occ'
import { CartActions } from '@spartacus/cart/base/core'
import { CommonService } from '../../shared/services/common.service'
import { SpinnerOverlayService } from '../../shared/components/spinner-overlay/spinner-overlay.service'
import { userRoles } from '../../models/user.model'
import { DialogResponse, VS_LAUNCH_CALLER } from '../config/dialog.config'
import {
  Ecommerce,
  EcommerceItem,
  GTMCartType,
  GTMDataLayer,
} from '../../shared/models/googleTagManager.model';
import {
  ItemListTypeEnum,
  GtmEvents,
  StoreTypeEnum,
} from '../../shared/enums/gtm.enum';
import { GoogleTagManagerService } from '../../shared/services/gtm.service';
import { QuoteCartFacade } from '../cart/mini-cart/store/mini-quote-cart.facade'

const DEFAULT_SEARCHBOX_CONFIG: SearchBoxConfig = {
  minCharactersBeforeRequest: 1,
  displayProducts: true,
  displaySuggestions: true,
  maxProducts: 4,
  maxSuggestions: 5,
  displayProductImages: true,
}
@Component({
  standalone: false,
  // tslint:disable-next-line:component-selector
  selector: 'cx-searchbox',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchBoxComponent {
  searchBox = {
    placeholder: 'Enter a part number/name',
  }
  config: SearchBoxConfig
  element: any
  searchQuery: any
  increment: boolean
  cartId: any
  userType: string
  maxQuantity: number
  hasStock = false
  quantity = 1
  cartEntry$: Observable<OrderEntry>
  subscription: Subscription
  minSearchLength = 3
  currency
  productId: any
  /**
   * Sets the search box input field
   */
  @Input('queryText')
  set queryText(value: string) {
    if (value) {
      this.search(value)
    }
  }
  public userRoles = userRoles
  iconTypes = ICON_TYPE
  /**
   * In some occasions we need to ignore the close event,
   * for example when we click inside the search result section.
   */
  private ignoreCloseEvent = false
  /**
   * The component data is optional, so that this component
   * can be reused without CMS integration.
   */
  user$: Observable<any>
  loggedIn = false
  @ViewChild('searchSuggestionsBox')
  searchSuggestionsBox: ElementRef
  @ViewChild('searchInput')
  searchInput: ElementRef

  checkPriceProduct = {}
  displaySearchLoader: boolean = false
  userId: any
  buycartId: any
  displayQuoteSpinner: boolean = false

  constructor(
    private auth: AuthService,
    public router: Router,
    protected searchBoxComponentService: SearchBoxComponentService,
    @Optional()
    protected componentData: CmsComponentData<CmsSearchBoxComponent>,
    protected winRef: WindowRef,
    public activeCartFacade: ActiveCartFacade,
    public commonService: CommonService,
    public quoteService: QuoteCartService,
    public launchDialogService: LaunchDialogService,
    public currentProductService: CurrentProductService,
    private renderer: Renderer2,
    private spinnerOverlayService: SpinnerOverlayService,
    private multiCartService: MultiCartFacade,
    private occAdapter: OccCartAdapter,
    private globalMessageService: GlobalMessageService,
    private actions$: Actions,
    private cRef: ChangeDetectorRef,
    private currencyService: CurrencyService,
    private pdpService: PDPService,
    private checkoutService: CheckoutService,
    private userAccountFacade: UserAccountFacade,
    private domSanitizer: DomSanitizer,
    private bulkService: BulkServiceService,
    private shoppingCartService: ShoppingCartService,
    private gtmService: GoogleTagManagerService,
    private quoteCartFacade: QuoteCartFacade,
  ) {
    this.domSanitizer.sanitize(
      SecurityContext.NONE,
      this.renderer.listen(document, 'click', this.bodyClick.bind(event))
    )
    /* this.quoteService.recieveCartId.subscribe(cartId => {
      this.cartId = cartId;

      }); */
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          return this.userAccountFacade.get()
        } else {
          return of(undefined)
        }
      })
    )
    this.user$.subscribe((res) => {
      this.userId = res?.recentSalesArea?.uid
    })

    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        this.loggedIn = success
        if (this.loggedIn) {
          this.userType = 'current'
          this.cartId = sessionStorage.getItem('cartId-current') || undefined
        }
        if (!this.loggedIn) {
          this.userType = 'anonymous'
          this.cartId = sessionStorage.getItem('cartId-anonymous') || undefined
        }
      },
      (error) => {}
    )
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        this.loggedIn = success
      },
      (error) => {}
    )
    this.currencyService.getActive().subscribe((data) => {
      this.currency = data
    })
    this.searchBoxComponentService.inSearchFlowOnly.next(false)
  }

  ngOnInit() {
      this.auth.isUserLoggedIn().subscribe((success) => {
        if (success) {
          this.activeCartFacade.getActiveCartId().subscribe((data) => {            
            this.buycartId = data
          })
        } else {
          this.userType = 'anonymous'
        }
      })
    this.bulkService.buyPLPCart.subscribe((data) => {
      if (data) {
        this.addToCartAdapter(this.buycartId, this.productId.code, 1)
      }
    })
  }

  results$: Observable<SearchResults> = this.config$.pipe(
    tap((c) => (this.config = c)),
    switchMap((config) => this.searchBoxComponentService.getResults(config))
  )

  ngOnDestroy() {
    this.bulkService.buyPLPCart.next(false)
  }
  /**
   * Returns the backend configuration or default configuration for the searchbox.
   */
  private get config$(): Observable<SearchBoxConfig> {
    if (this.componentData) {
      return this.componentData.data$.pipe(
        map((c) => {
          return {
            ...c,
            displayProducts:
              (c?.displayProducts as any) === 'true' ||
              c?.displayProducts === true,
            displayProductImages:
              (c?.displayProductImages as any) === 'true' ||
              c?.displayProductImages === true,
            displaySuggestions:
              (c?.displaySuggestions as any) === 'true' ||
              c?.displaySuggestions === true,
          }
        })
      ) as Observable<SearchBoxConfig>
    } else {
      return of(DEFAULT_SEARCHBOX_CONFIG)
    }
  }
  /**
   * Closes the searchbox and opens the search result page.
   */
  search(query: string): void {
    this.searchQuery = this.domSanitizer.sanitize(SecurityContext.HTML, query)
    this.searchBoxComponentService.search(
      this.domSanitizer.sanitize(SecurityContext.HTML, query),
      this.config
    )
    // force the searchbox to open
    this.open()
  }

  envokSearch() {
    this.search(
      this.domSanitizer.sanitize(SecurityContext.HTML, this.searchQuery)
    )
    this.searchInput.nativeElement.value = ''
    this.router.navigate([
      'search',
      this.domSanitizer.sanitize(SecurityContext.HTML, this.searchQuery),
    ])
    this.searchQuery = this.domSanitizer.sanitize(
      SecurityContext.HTML,
      this.searchInput.nativeElement.value
    )
  }
  /**
   * Opens the typeahead searchbox
   */
  open(): void {
    this.searchBoxComponentService.toggleBodyClass('searchbox-is-active', true)
  }
  /**
   * Closes the typehead searchbox.
   */
  close(event: UIEvent, force?: boolean): void {
    // Use timeout to detect changes
    setTimeout(() => {
      if ((!this.ignoreCloseEvent && !this.isSearchboxFocused()) || force) {
        this.blurSearchBox()
        this.searchInput.nativeElement.value = ''
        this.searchQuery = this.searchInput.nativeElement.value
      }
    })
  }
  protected blurSearchBox(): void {
    this.searchBoxComponentService.toggleBodyClass('searchbox-is-active', false)
  }

  // Check if focus is on searchbox or result list elements
  private isSearchboxFocused(): boolean {
    return (
      this.getResultElements().includes(this.getFocusedElement()) ||
      this.winRef.document.querySelector('input[aria-label="search"]') ===
        this.getFocusedElement()
    )
  }

  avoidReopen(event: UIEvent): void {
    if (this.searchBoxComponentService.hasBodyClass('searchbox-is-active')) {
      this.close(event)
      event.preventDefault()
    }
  }
  // Return result list as HTMLElement array
  private getResultElements(): HTMLElement[] {
    return Array.from(
      this.winRef.document.querySelectorAll('.products > a, .suggestions > a')
    )
  }
  // Return focused element as HTMLElement
  private getFocusedElement(): HTMLElement {
    return this.winRef.document.activeElement as HTMLElement
  }
  private getFocusedIndex(): number {
    return this.getResultElements().indexOf(this.getFocusedElement())
  }
  // Focus on previous item in results list
  focusPreviousChild(event) {
    event.preventDefault() // Negate normal keyscroll
    const [results, focusedIndex] = [
      this.getResultElements(),
      this.getFocusedIndex(),
    ]
    // Focus on last index moving to first
    if (results.length) {
      if (focusedIndex < 1) {
        results[results.length - 1].focus()
      } else {
        results[focusedIndex - 1].focus()
      }
    }
  }
  // Focus on next item in results list
  focusNextChild(event) {
    event.preventDefault() // Negate normal keyscroll
    const [results, focusedIndex] = [
      this.getResultElements(),
      this.getFocusedIndex(),
    ]
    // Focus on first index moving to last
    if (results.length) {
      if (focusedIndex >= results.length - 1) {
        results[0].focus()
      } else {
        results[focusedIndex + 1].focus()
      }
    }
  }
  /**
   * Opens the PLP with the given query.
   *
   * TODO: if there's a single product match, we could open the PDP.
   */
  launchCheckFlag: boolean = false

  launchSearchResult(
    event: UIEvent,
    query: string,
    launchCheck: boolean
  ): void {
    this.launchCheckFlag = launchCheck
    const sanitiedQuery = this.domSanitizer.sanitize(
      SecurityContext.HTML,
      query
    )
    if (!sanitiedQuery || sanitiedQuery.trim().length === 0) {
      return
    }
    this.searchInput.nativeElement.value = ''
    this.searchQuery = this.searchInput.nativeElement.value
    this.close(event)
    this.searchBoxComponentService.launchSearchPage(query)
    this.gotoProduct(launchCheck)
  }
  gotoProduct(launchCheck) {
    let result
    if (launchCheck) {
      this.results$.subscribe((results) => {
        result = results
        if (result.products?.length === 1 && this.launchCheckFlag) {
          this.searchInput.nativeElement.value = ''
          this.setQuantity(result.products[0])
          this.launchCheckFlag = false
          this.cRef.detectChanges()
          this.router.navigateByUrl(result.products[0].url)
          this.searchQuery = this.searchInput.nativeElement.value
        } else {
          this.launchCheckFlag = false
          this.cRef.detectChanges()
        }
      })
    }
  }
  /**
   * Disables closing the search result list.
   */
  disableClose(): void {
    this.ignoreCloseEvent = true
  }

  /**
   * Clears the search box input field
   */
  public clear(el: HTMLInputElement): void {
    this.disableClose()
    el.value = ''
    this.searchBoxComponentService.clearResults()
  }

  openCRDdialog(product, cartFlag) {
    const componentdata = {};
    let valInstance;

    const crdInputDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.CRD_INPUT_MODAL,
      undefined,
      undefined,
      componentdata
    )

    if (crdInputDialog) {
      crdInputDialog.pipe(take(1)).subscribe((value) => {  
        valInstance = value.instance.launchDialogService._dialogClose._value;
        if (valInstance.reason == 'crd-selected') {
          if(cartFlag === 'buy'){
            this.addToCart(product, valInstance.data);
          } else if(cartFlag === 'quote'){
            this.getQuote(product, valInstance.data);
          }          
        }
      })
    }
  }

  addToCart(product, crd) {
    this.searchBoxComponentService.inSearchFlowOnly.next(true)
    this.productId = product
    if (product) {
      this.cartEntry$ = this.activeCartFacade.getEntry(product.code)
    } else if (product.code) {
      this.cartEntry$ = this.activeCartFacade.getEntry(product.code)
      // force hasStock and quantity for the time being, as we do not have more info:
      this.quantity = 1
      this.hasStock = true
    } else {
      this.subscription = this.currentProductService
        .getProduct()
        .pipe(filter(Boolean))
        .subscribe((product: any) => {
          this.cartEntry$ = this.activeCartFacade.getEntry(product.code)
        })
    }
    const quantity = 1
    let buyCartId = ''
    this.activeCartFacade
      .getEntry(product.code)
      .subscribe((entry) => {
        this.blurSearchBox()
        this.increment = false
        this.searchInput.nativeElement.value = ''
        if (entry) {
          this.increment = true
        }
        this.activeCartFacade
          .getActiveCartId()
          .pipe(take(1))
          .subscribe((res: any) => {
            if (res) {
              buyCartId = res
              this.addToCartAdapter(buyCartId, product.code, quantity, product, crd)
            } else {
              this.occAdapter
                .create('current')
                .pipe(take(1))
                .subscribe((occData) => {
                  buyCartId = occData.code
                  this.addToCartAdapter(buyCartId, product.code, quantity, product, crd)
                })
            }
          })

        this.increment = false
      })
      .unsubscribe()
  }
  addToCartAdapter(cartId, productCode, quantity, product?, crd?) {
    const quoteCartType = sessionStorage.getItem('quoteCartType')
    const isRfqCart = sessionStorage.getItem('isRfqCart')
    const urlParam = ['users', this.userType, 'carts', cartId, 'vsentries']
    const url = this.commonService.constructUrl(urlParam)

    const apiParams = {
      quantity,
      product: {
        code: productCode,
      },
      customerRequestedDate: crd
    }
    if (
      quoteCartType != '' &&
      quoteCartType != 'undefined' &&
      isRfqCart == 'false'
    ) {
      this.deleteCart(cartId, productCode)
    } else {
      this.spinnerOverlayService.show()
      this.commonService.postData(url, apiParams).subscribe(
        (result: any) => {
          this.cartEntry$ = this.activeCartFacade.getEntry(productCode)
          this.bulkService.newCartId.next(false)
          this.multiCartService.loadCart({
            userId: 'current',
            cartId: cartId,
            extraData: {
              active: true,
            },
          })

          if(product){
            this.pushAddToCartEvent(product, cartId);
          }

          this.actions$
            .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
            .subscribe((r) => {
              this.spinnerOverlayService.hide()
              this.router.navigate(['cart'])
              // this.searchBoxComponentService.inSearchFlowOnly.subscribe(
              //   (status) => {
              //     if (status) {

              //       // this.searchBoxComponentService.inSearchFlowOnly.next(false);
              //     }
              //   }
              // )
            })
        },
        (er) => {
          this.spinnerOverlayService.hide()
          let errorMsg = ''
          this.bulkService.newCartId.next(false)
          if (er.error?.errors[0]?.message == '5001') {
            errorMsg = 'searchbox.noPriceFoundInSAP'
          } else if (er.error?.errors[0]?.message == '500') {
            errorMsg = 'searchbox.lostConnectivityToSAP'
          } else {
            errorMsg = 'searchbox.errorAddingProductToCart'
          }

          if (errorMsg != 'searchbox.errorAddingProductToCart') {
            this.globalMessageService.add(
              { key: errorMsg },
              GlobalMessageType.MSG_TYPE_ERROR,
              10000
            )
            window.scroll(0, 0)
          } else {
            this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR)
          }
        }
      )
    }
  }
  deleteCart(cartId, productCode) {
    // this.OpenPopUp = false;
    this.spinnerOverlayService.show()
    this.multiCartService.deleteCart(cartId, this.userType)
    this.actions$
      .pipe(ofType(CartActions.DELETE_CART_SUCCESS))
      .pipe(take(1))
      .subscribe((r) => {
        sessionStorage.setItem('quoteCartType', '')
        sessionStorage.setItem('isRfqCart', '')
        this.spinnerOverlayService.hide()
        this.globalMessageService.add(
          { key: 'searchbox.existingCartRemoved' },
          GlobalMessageType.MSG_TYPE_ERROR,
          10000
        )
        window.scroll(0, 0)
        this.occAdapter
          .create('current')
          .pipe(take(1))
          .subscribe((occData) => {
            cartId = occData.code
            sessionStorage.setItem('quoteCartType', '')
            sessionStorage.setItem('isRfqCart', '')
            this.addToCartAdapter(cartId, productCode, 1)
            this.multiCartService.loadCart({
              userId: 'current',
              cartId: cartId,
              extraData: {
                active: true,
              },
            })
          })
      })

    this.actions$
      .pipe(ofType(CartActions.DELETE_CART_FAIL))
      .pipe(take(1))
      .subscribe(
        (r) => {
          this.spinnerOverlayService.hide()
          this.globalMessageService.add(
            { key: 'searchbox.clearCartFailed' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }

  // CHECK PRICE CUSTOMIZATION FOR GLOBAL SEARCH  - START
  checkPrice(product) {
    this.router.navigateByUrl(product.url)
  }
  checkPrice_Custom(product) {
    this.displaySearchLoader = true
    this.searchBoxComponentService.checkPrice(product).subscribe(
      (data) => {
        if (!data['errors']) {
          this.checkPriceProduct[product.code] = {
            display: true,
            code: product.code,
            price: data['price'],
            status: 'BUY',
          }
          this.cRef.detectChanges()
          this.displaySearchLoader = false
        } else {
          this.checkPriceErrorHandling(data, product)
        }
      },
      (err) => {
        this.checkPriceErrorHandling(err, product)
      }
    )
  }

  checkPriceErrorHandling(data, product) {
    if (data['errors'] !== undefined) {
      if (data['errors'][0]?.message === '5001') {
        this.checkPriceProduct[product.code] = {
          display: true,
          code: product.code,
          price: undefined,
          status: 'QUOTE',
        }
        this.cRef.detectChanges()
        this.displaySearchLoader = false
      } else if (data.errors[0]?.message === '500') {
        this.displaySearchLoader = false
        this.displayErrorOnScreen()
      }
    } else {
      this.displaySearchLoader = false
      this.displayErrorOnScreen()
    }
  }

  displayErrorOnScreen() {
    this.globalMessageService.add(
      { key: 'searchbox.requestCantBeProcessed' },
      GlobalMessageType.MSG_TYPE_ERROR,
      5000
    )
    window.scrollTo(0, 0)
  }
  // CHECK PRICE CUSTOMIZATION FOR GLOBAL SEARCH  - END

  getQuote(product, crd) {
    this.displayQuoteSpinner = true;
    this.cRef.detectChanges();
    this.cartId = sessionStorage.getItem('cartId-' + this.userType)
    this.quoteService
      .getCart(this.cartId, this.userType)
      .subscribe((success: any) => {
        if (this.loggedIn || this.userType === 'current') {
          this.cartId = success['code']
          sessionStorage.setItem('cartId-' + this.userType, this.cartId)
        } else if (!this.loggedIn || this.userType === 'anonymous') {
          this.cartId = success['guid']
          sessionStorage.setItem('cartId-' + this.userType, this.cartId)
        }
        sessionStorage.setItem('cartStatus-' + this.userType, 'added')
        var newDate = new Date()
        sessionStorage.setItem('quoteCart-requestedDate', newDate.toISOString())
        this.blurSearchBox();
        this.openQuoteModal(product, crd);
      })
  }
  openQuoteModal(product, crd) {
    var Obj = {
      cartId: this.cartId,
      userType: this.userType,
      product: product,
      type: 'search',
      quantity: 1,
      crd: crd,
      view: 'search-box'
    }

    this.commonService.sendProduct(Obj)
    const componentdata = {}

    const getAQuoteDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.GET_A_QUOTE,
      undefined,
      undefined,
      componentdata
    )
    if (getAQuoteDialog) {
      getAQuoteDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }

    this.displayQuoteSpinner = false;
    setTimeout(() => {
      this.quoteCartFacade.loadCart();
    }, 500);
  }
  private openModal(product) {
    const componentdata = {
      entry$: this.cartEntry$,
      cart$: this.activeCartFacade.getActive(),
      loaded$: this.activeCartFacade.isStable(),
      quantity: this.quantity,
      increment: this.increment,
      product: product,
    }

    const addToCartDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.ADD_TO_CART,
      undefined,
      undefined,
      componentdata
    )
    if (addToCartDialog) {
      addToCartDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }
  }
  navigateToReplacementProduct(event, product) {
    this.searchInput.nativeElement.value = ''
    this.router.navigateByUrl(product.replacementProductUrl)
    this.searchQuery = this.searchInput.nativeElement.value
  }

  bodyClick($ev) {
    if (
      this?.searchInput &&
      !this?.searchInput?.nativeElement.contains(event.target) &&
      this.searchSuggestionsBox &&
      !this.searchSuggestionsBox.nativeElement.contains(event.target)
    ) {
      this.close($ev)
    }
  }
  setQuantity(product) {
    this.commonService.getCount(1)
    this.gtmSelectItemEvent(product)
  }

  gtmSelectItemEvent(product) {
    let producitem: EcommerceItem[] = [];
    if (product) {
      producitem.push({
        item_id: product?.code,
        item_name: product?.name,
        discount: product?.discountPercentage
          ? + product?.discountPercentage
          : '',
        index: 0,
        item_list_id: ItemListTypeEnum.Search,
        item_list_name: ItemListTypeEnum.Search,
        price: '', //discountPrice not available
      });
      let purchaseEcommerceEcommerce: Ecommerce = {
        item_list_id: ItemListTypeEnum.Search,
        item_list_name: ItemListTypeEnum.Search,
        items: producitem,
      };
      let selectItemDataLayer: GTMDataLayer = {
        event: GtmEvents.SelectItem,
        ecommerce: purchaseEcommerceEcommerce,
      };
      this.gtmService.sendEvent(selectItemDataLayer);
    }
  }

  pushAddToCartEvent(productData, cartId) {
    const item: EcommerceItem = {
      price: productData?.netPrice?.value,
      quantity: 1,
      item_id: productData?.code,
      item_name: productData?.name,
      discount: productData?.discountPercentage
        ? Number(productData?.discountPercentage)
        : '',
      item_list_id: ItemListTypeEnum.ProductDetail,
      item_list_name: ItemListTypeEnum.ProductDetail,
      item_category: productData?.product?.categories[0]?.name || '',
      item_category2: productData?.product?.categories[1]?.name || '',
      item_category3: productData?.product?.categories[2]?.name || '',
      item_category4: productData?.product?.categories[3]?.name || '',
      item_category5: productData?.product?.categories[4]?.name || '',
      item_variant: '',
      index: 0,
    };

    const eventData: Ecommerce = {
      currency: productData?.netPrice?.currencyIso || '',
      value:
        productData?.netPrice?.value *
          productData.value || '',
      items: [item],
    };
    const event: GTMDataLayer = {
      event: GtmEvents.AddToCart,
      ecommerce: eventData,
      commerceType: GTMCartType.BUY_CART,
      cartType: productData?.cartType ?? '',
      cart_id: cartId
    };
    this.gtmService.sendEvent(event);
  }
}
